import { z } from 'zod';
// BlockContent is simplified to `any` for validations
const BlockContentSchema = z.object({
    blocks: z.array(z.any())
});
export const I18nBlockContentSchema = z.object({
    english: BlockContentSchema,
    spanish: BlockContentSchema
});
//# sourceMappingURL=blockContent.js.map